export default __webpack_public_path__ + "static/media/ic_card.300e1597.svg";